// TODO: double check that scene.width/height should be the rgb w/h

import { combineReducers } from 'redux'
import * as types from 'models/actionTypes'
import { STATE_NOMINAL, STATE_FETCHING, STATE_ERROR } from 'constants/stateTypes'
import { getManifestStackables } from 'utils/stackables'
import { manifestHasImageURL } from 'Renderer/manifestImageLoader'
import { UNSUPPORTED_ROOMTYPES } from 'models/scenes/constants'

// byId: a map between ids and item properties
const initialState = {
    fetchState: STATE_NOMINAL,
    selectedSceneId: null,
    byId: {},
}

export const fetchState = (state = initialState.fetchState, action) => {
    switch (action.type) {
        case types.REQUEST_SCENES:
        case types.REQUEST_SCENE:
            return STATE_FETCHING
        case types.RECEIVE_SCENES:
        case types.RECEIVE_SCENE:
        case types.RECEIVE_COMPILED_COMPOSITION:
            return STATE_NOMINAL
        case types.FAILED_RECEIVE_SCENES:
        case types.FAILED_RECEIVE_SCENE:
            return STATE_ERROR
        default:
            return state
    }
}

const processServerScene = (sceneItem) => {
    const hasFloor = !!(
        sceneItem.manifest.plane_orientation_0 &&
        sceneItem.manifest.plane_orientation_0.planeData &&
        sceneItem.manifest.plane_orientation_0.planeData.length &&
        sceneItem.manifest.plane_orientation_0.planeData.some((p) => p.class === 'floor')
    )
    // If there is a floor we must have at least 2 planes to have a wall
    const hasWall = !!(
        sceneItem.manifest.plane_orientation_0 &&
        sceneItem.manifest.plane_orientation_0.planeData &&
        sceneItem.manifest.plane_orientation_0.planeData.length > (hasFloor ? 1 : 0)
    )
    const supportsShadows = hasFloor
    const supportsForegroundOcclusion = !!sceneItem.manifest.foreground_0

    const supportsDepthOcclusion = manifestHasImageURL(sceneItem.manifest, 'depth_occlusion_0')

    const supportsOcclusion = supportsForegroundOcclusion || supportsDepthOcclusion
    const thumbUrl = sceneItem.manifest.thumbnail || (sceneItem.thumbnails && sceneItem.thumbnails.url) || null
    const hasWallPaint = !!(
        sceneItem.manifest.residual_0 ||
        sceneItem.manifest.residual_0_webp ||
        sceneItem.manifest.shading_0 ||
        sceneItem.manifest.shading_0_webp
    )

    let roomType = null
    if (sceneItem.roomType && !UNSUPPORTED_ROOMTYPES.includes(sceneItem.roomType)) {
        roomType = sceneItem.roomType
    }

    return {
        [sceneItem.sceneId]: {
            sceneId: sceneItem.sceneId,
            jobId: sceneItem.jobId,
            name: sceneItem.name || '',
            depthUrl: sceneItem.depthUrl,
            creationDate: sceneItem.creation,
            defaultX: 400,
            defaultY: 150,
            wid: sceneItem.wid,
            thumbUrl,
            manifest: sceneItem.manifest,
            stackables: getManifestStackables(sceneItem.manifest),
            hasFloor,
            hasWall,
            supportsShadows,
            supportsOcclusion,
            supportsForegroundOcclusion,
            supportsDepthOcclusion,
            isStock: sceneItem.isStock,
            hasWallPaint,
            roomType,
        },
    }
}

export const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case types.RECEIVE_SCENES:
            return Object.assign({}, state, ...action.scenes.map(processServerScene))
        case types.RECEIVE_SCENE:
        case types.RECEIVE_COMPILED_COMPOSITION:
            return {
                ...state,
                ...processServerScene(action.scene),
            }
        case types.UPDATE_SCENE_MANIFEST:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    manifest: {
                        ...state[action.id].manifest,
                        [action.key]: action.value,
                    },
                },
            }
        default:
            return state
    }
}

export const selectedSceneId = (state = initialState.selectedSceneId, action) => {
    let firstDemoSceneId
    switch (action.type) {
        case types.SELECT_SCENE:
            return action.id
        case types.RECEIVE_SCENES:
            // TODO Move to middleware
            if (action.scenes.length > 0) {
                for (let i = 0; i < action.scenes.length; i += 1) {
                    if (action.scenes[i].sceneId === state) {
                        return state
                    }
                    if (!firstDemoSceneId && action.scenes[i].wid === 10016) {
                        firstDemoSceneId = action.scenes[i].sceneId
                    }
                }
                if (firstDemoSceneId) {
                    return firstDemoSceneId
                }
                return action.scenes[0].sceneId
            }
            return state
        default:
            return state
    }
}

export default combineReducers({
    fetchState,
    byId,
    selectedSceneId,
})
